import { TheNightlySection } from '@news-mono/common'
import { PageType, StaticRoutes } from '@news-mono/web-common'
import { createLatestEditionPage } from './latestEdition'
import { createSpecificEditionPage } from './specificEdition'

const baseUrl = '/editions'

export const ePaper: StaticRoutes<TheNightlySection> = {
    '/editions': (services) => {
        return createLatestEditionPage(services, 'default', 'The Nightly')
    },
}
